import { SVGProps } from "react";

export const TableViewIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="#000"
        d="M3.5 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m17.25 0a.75.75 0 0 0 0-1.5h-14a.75.75 0 0 0 0 1.5zM21.5 12a.75.75 0 0 1-.75.75h-14a.75.75 0 0 1 0-1.5h14a.75.75 0 0 1 .75.75m-18 .75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m18 5.25a.75.75 0 0 1-.75.75h-14a.75.75 0 0 1 0-1.5h14a.75.75 0 0 1 .75.75m-18 .75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  );
};
